// extracted by mini-css-extract-plugin
export default {"logoutIcon":"LogoutButton__logoutIcon--2bT"};